<template>
  <multiselect
    ref="multiselect"
    class="multiselect-offers"
    :class="{'_mob': sizeMdMax}"
    :value="getSelectedOffer"
    :options="options"
    :max-height="270"
    :searchable="false"
    :allow-empty="false"
    select-label=""
    selected-label=""
    deselect-label=""
    track-by="id"
    label="formattedRange"
    :disabled="disabled"
    @input="selectOption"
    @open="$emit('open', $event)"
    @close="$emit('close', $event)"
  >
    <template #singleLabel="{ option: { formattedRange } }">
      <div
        class="
              multiselect-offers__placeholder
              font-text-small
              u-text-secondary
            "
        v-html="placeholder"
      >
      </div>
      <div
        class="multiselect-offers__title font-semibold"
        v-html="formattedRange"
      ></div>
    </template>
    <template #caret>
      <button
        type="button"
        class="multiselect-offers__caret u-decor u-flex-shrink-0"
      >
        <svg-inline tag="span" dir="down" class="u-stroke-deep-current">
          <icon icon="icon-angle-up" classMod="no-fill"/>
        </svg-inline>
      </button>
    </template>
    <template #option="{ option: { formattedRange, formattedRangeFullMonth,freeSpaces, priceValue, priceWithDiscount, totalSpaces} }" >
      <div class="multiselect-offers__option" v-if="!sizeMdMax">
        <div  v-html="formattedRange"></div>
        <div class="option__right _grey-pale" v-if="freeSpaces > 0">
          <div class="option__right-price _dot">
            {{ price(priceWithDiscount) }}
          </div>
          <div class="option__right-place "
               :class= "leftColorClasses(freeSpaces, totalSpaces)"
          >
            {{ freeSpaces }}
            {{freeSpaces > 4
            ? $t("bookingPopup.fieldset.places[2]")
            : freeSpaces > 1
              ? $t("bookingPopup.fieldset.places[1]")
              : $t("bookingPopup.fieldset.places[0]")
            }}
          </div>
        </div>
        <div class="_no-places" v-else>
          {{$t("bookingPopup.fieldset.noPlaces")}}
        </div>
      </div>
      <div v-else class="multiselect-offers__option-mob">
        <div class="option-mob__left">
          <div class="option-mob__left-range" v-html="formattedRangeFullMonth"></div>
          <div class="option-mob__left-places"
               v-if="freeSpaces > 0"
               :class= "leftColorClasses(freeSpaces, totalSpaces)"
          >
            {{ freeSpaces }}
            {{freeSpaces > 4
            ? $t("bookingPopup.fieldset.places[2]")
            : freeSpaces > 1
              ? $t("bookingPopup.fieldset.places[1]")
              : $t("bookingPopup.fieldset.places[0]")
            }}
          </div>
          <div class="option-mob__left-places _dark-grey" v-else>
            {{$t("bookingPopup.fieldset.noPlaces")}}
          </div>
        </div>
        <div class="option-mob__right">
          <div class="option-mob__right-price">{{ price(priceWithDiscount) }}</div>
          <div class="option-mob__right-btn">{{$t("bookingPopup.choose")}}</div>
        </div>
      </div>

    </template>
    <template #afterList>
      <div class="multiselect-offers__loader" v-if="awaitNextPage">
        <loader visible/>
      </div>
    </template>
  </multiselect>
</template>

<script>

import {defineComponent} from "vue";
import Multiselect from "vue-multiselect";
import Icon from "@/components/icons/index.vue";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import { sizeMdMax } from "@/assets/js/utils/mq";
import loader from "@/components/ui-kit/loader-icon";
export default defineComponent({
  components: {
    loader,
    SvgInline,
    Icon,
    Multiselect,
    sizeMdMax
  },
  props: {
    options: {
      type: Array,
      required: false,
    },
    selectedOption: {
      type: Object,
      required: false,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
    },
    currency: {
      type: Object,
      required: false,
    },
    isOfferSelected: {
      type: Boolean,
      default: false,
    },
    awaitNextPage: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    getSelectedOffer() {
      if(this.isOfferSelected) {
        return this.selectedOption
      }
      return {}
    },
    sizeMdMax,
  },
  methods: {
    price (datePrice) {

      const priceFormatted = Math.ceil(datePrice)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");

      return `${this.currency?.title.charAt(0)} ${priceFormatted}`;
    },
    selectOption (evt) {
      this.$emit('selectOption', evt)
    },
    leftColorClasses(freeSpaces, totalSpaces) {
      let leftLessThanHalf =  (
        freeSpaces <=
        totalSpaces / 2
      );
      return leftLessThanHalf ? "u-text-violet-3" : "u-text-green-click";
    },
  },
  mounted() {
    this.options.forEach((item, i) => {
      if(item.freeSpaces == 0) {
        this.options[i].$isDisabled = true;
      }
    })
  }
})
</script>

<style lang="scss" scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";
$m: ".multiselect";
.multiselect-offers  {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  box-sizing: border-box;
  border: 1px solid var.$gray-dark;
  padding: 9px 16px;
  transition: var.$transition-default;
  height: fit-content;
  min-height: 56px;


  &--invalid {
    border: 1px solid var.$ruby-300;
  }

  &:not(:first-child) {
    border-top: none;
  }

  &:first-child {
    border-top-left-radius: var.$rounded-8;
    border-top-right-radius: var.$rounded-8;

    &.multiselect--above.multiselect--active {
      border-radius: 0;
    }
  }

  &:last-child {
    border-bottom-right-radius: var.$rounded-8;
    border-bottom-left-radius: var.$rounded-8;
  }

  &#{$m}--active {
    border-color: var.$black;
  }

  &__placeholder {
    margin-bottom: 2px;
  }

  &__title {
    color: var.$black;
  }

  &__caret {
    @include mixin.button-reset();
    width: 20px;
    padding: 0;
    position: absolute;
    /*margin-left: 20px;*/
    color: var.$secondary;
    transition: var.$transition-default;

    #{$m}--active & {
      color: var.$black;
      transform: rotate(-180deg);
    }
  }

  &__option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: var.$transition-default;
    width: fit-content;
    min-width: 311px;
    font-family: "SF Pro Text";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 128.571% */
    letter-spacing: -0.28px;


    ._dot {
      position: relative;
      padding-right: 12px;

      &:after {
        background: 0 0;
        color: #d1d7e8;
        content: "●";
        font-size: 6px;
        display: block;
        position: absolute;
        right: 0;
        top: 1px;
        margin-top: 0;
      }
    }


    ._grey-pale {
      padding: 4px 6px;
      border-radius: 6px;
      background: var(--grey-pale, #F6F7FA);
    }

    .option {
      &__right {
        display: flex;
        align-items: center;
        gap: 6px;
        @include mixin.size-lg-min {
          margin-left: 20px;
        }

        &-place {
          font-family: "SF Pro Text";
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 18px;
          letter-spacing: -0.28px;
        }
        &-price {
          color: var(--black, #222);
          font-family: "SF Pro Text";
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 18px;
          letter-spacing: -0.28px;
        }
      }
    }
  }

  &__option-mob {
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 12px;
  }
  &__mob-header {
    color: var(--black, #222);
    text-align: center;
    font-family: "SF Pro Text";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 19px; /* 118.75% */
    letter-spacing: -0.32px;
    display: flex;
    width: 100%;

  }
  >>> {
    #{$m} {


      &__tags {
        flex-grow: 1;
        min-width: 1px;
        padding: 0;
        min-height: 0;
        border: none;
        background: none;
      }

      &__single {

        line-height: inherit;
        background: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-height: 36px;
      }

      &__content {
        padding: 8px 1px 8px 8px!important;
      }

      &__content-wrapper {
        width: auto;
        top: calc(100% + 1px);
        right: -1px;
        left: -1px;
        box-shadow: 1px 4px 20px rgba(var.$secondary, 0.35);
        border: none;
        border-bottom-right-radius: var.$rounded-8;
        border-bottom-left-radius: var.$rounded-8;
      }

      &__element {
        padding: 0;
        /* width: calc(100vw - 20px - 16px - 24px);
         max-width: calc(400px - 24px);*/

        @include mixin.size-lg-min {
          max-width: 335px;
        }

      }

      &__option {
        border-radius: 6px;
        padding: 12px;
        min-height: 0;
        color: var.$black;
        transition: var.$transition-default;
        overflow: hidden;

        &--selected {
          background: var.$green-main;

          &:not(#{$m}__option--highlight) {
            color: var.$white;
          }
          ._grey-pale {
            background: #fff;
          }
        }

        &--highlight {
          background: var.$gray-pale;
          ._grey-pale {
            background: #fff;
          }
        }
        &--disabled {
          background: none!important;
        }
        &:hover .multiselect-offers__option {
          @include mixin.size-lg-min {
            transform: translateX(calc(311px - 100%));
          }

        }
      }

      &--above {
        #{$m} {
          &__content-wrapper {
            top: auto;
            bottom: calc(100% + 1px);
            border-top-left-radius: var.$rounded-8;
            border-top-right-radius: var.$rounded-8;
          }
        }
      }

    }

    .serp-input-wrapper {
      .serp-input {
        padding: 9px 0;
        font-size: 14px;
      }
    }
  }


}

._mob {
  position: unset!important;
  >>> {
    #{$m} {
      &__content-wrapper {
        max-height: none!important;
        top: 158px!important;
        position: absolute;
        height: calc(100vh - 58px);
        border-radius: 0;
        border-bottom-right-radius: 0px!important;
        border-bottom-left-radius: 0px!important;
        box-shadow: none!important;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE 10+ */
        ::-webkit-scrollbar-track {
          display: none !important;
          -webkit-box-shadow: none !important;
          box-shadow: none !important;
          background-color: transparent !important;
        }

        ::-webkit-scrollbar {
          display: none;
          width: 0px !important;
          background-color: transparent !important;
        }
        ::-webkit-scrollbar-thumb {
          display: none !important;
          background-color: transparent !important;
          width: 0px !important;
        }
      }

      &__content {
        padding: 16px!important;
        display: flex!important;
        flex-direction: column;
        gap: 8px;

      }

      &__option {
        background: var.$white;
        box-shadow: 1px 2px 45px 0px rgba(153, 153, 169, 0.22);
        border-radius: 8px!important;
        &--highlight {
          border: 1px solid var(--grey-divider, #DBDFE9);

          .option-mob__right-btn {
            background: var(--grey-divider, #D1D7E8);
          }

        }
      }
    }
  }
}
.option-mob {
  &__left {
    display: flex;
    flex-direction: column;
    gap: 6px;
    &-range {

      font-family: "SF Pro Text";
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px;
      letter-spacing: -0.28px;
    }
    &-places {
      border-radius: 6px;
      border: 1px solid var(--grey-divider, #D1D7E8);
      background: var(--white, #FFF);
      box-shadow: 2px 2px 15px 0px rgba(153, 153, 169, 0.15);
      padding: 0px 6px;
      height: 20px;
      display: flex;
      align-items: center;
      /* gap: 2px; */
      width: fit-content;
      font-family: "SF Pro Text";
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 16px; /* 133.333% */
      letter-spacing: -0.24px;
    }
  }
  &__right {
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: flex-end;
    &-price {

      text-align: right;
      /* h5 */
      font-family: "SF Pro Text";
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 19px; /* 118.75% */
      letter-spacing: -0.32px;
    }
    &-btn {
      display: flex;
      height: 32px;
      padding: 0px 12px;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      background: var(--grey-light, #EEEEF2);
      color: var(--black, #222);
      text-align: center;
      font-family: "SF Pro Text";
      font-size: 13px;
      font-style: normal;
      font-weight: 600;
      line-height: 17px;
      letter-spacing: -0.26px;
    }
  }
}
._no-places {
  color: var(--text-grey, #9999A9);
  font-family: "SF Pro Text";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.28px;
}
._dark-grey {
  color: var(--dark-grey-secondary, #828296);
}

</style>
